export default __webpack_public_path__ + "static/intro_mobile-poster-59dc22d53b95f581cd34e40bceb24816.avif";